<template>
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">Our Instructors</h1>
      <div class="stats-container">
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-users"></i>
          </div>
          <div class="stat-content">
            <span class="stat-value">{{ totalInstructors }}</span>
            <span class="stat-label">Total Instructors</span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-book"></i>
          </div>
          <div class="stat-content">
            <span class="stat-value">{{ totalCourses }}</span>
            <span class="stat-label">Total Courses</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    totalInstructors: {
      type: Number,
      required: true
    },
    totalCourses: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.page-header {
  margin-bottom: 2.5rem;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.page-title {
  font-size: 2.2rem;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
}

.page-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  border-radius: var(--radius-lg);
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  max-width: 1000px;
  margin: 0 auto;
  margin-bottom: 1.2rem;
}

.stat-card {
  background: var(--bg-white);
  border-radius: var(--radius-xl);
  padding: 1.1rem 1.2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  box-shadow: var(--shadow-lg);
  border: none;
  transition: var(--transition);
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--primary-light), transparent);
  opacity: 0.5;
  z-index: 0;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-xl);
}

.stat-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  border-radius: var(--radius-xl);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bg-white);
  font-size: 1.75rem;
  position: relative;
  z-index: 1;
  box-shadow: var(--shadow-md);
}

.stat-content {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--text-dark);
  line-height: 1;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.stat-label {
  font-size: 1rem;
  color: var(--text-medium);
  margin-top: 0.5rem;
  font-weight: 500;
}

@media (max-width: 992px) {
  .page-title {
    font-size: 2.5rem;
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 2rem;
  }
  
  .stats-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 1.75rem;
  }
}
</style> 